import { ComponentsOverrides, Theme } from '@mui/material';

export const MuiAutocomplete: { styleOverrides: ComponentsOverrides<Theme>['MuiAutocomplete'] } = {
    styleOverrides: {
        // new styles
        hasPopupIcon: {
            paddingRight: 0,
        },
        popupIndicator: {
            color: 'inherit',
            // TODO: move to icon-button sizeMedium
            minWidth: 40,
            minHeight: 40,
        },
        clearIndicator: {
            color: 'inherit',
            // TODO: move to icon-button sizeMedium
            minWidth: 40,
            minHeight: 40,
        },
        root: {
            marginTop: '0 !important',

            // mui-autocomplete adds a form-control with a margin-top
            '& > .MuiFormControl-root': {
                marginTop: 0,
            },
        },
        noOptions: ({ theme }) => ({
            color: theme.palette.grey[700],
        }),

        // Old styles
        option: {
            padding: '0 !important',

            '& > div': {
                padding: '21px 24px 17px 24px',
                textOverflow: 'ellipsis',
                overflow: 'hidden',
                whiteSpace: 'nowrap',
            },
        },
        listbox: {
            height: '100%',
        },
    },
};
